// apps/web/src/pages/spread/SpreadLeftPanel.tsx
//
// Phase 9 Plan 11 Task 2 — left-panel composition.
//
// Composes <SpreadTabStrip> (top — horizontal tab strip across spreads) and
// <BatchSetStrip> (below — vertical sortable list of batch sets) per UI-SPEC
// §"Spread Composer shell" component tree lines 140-146.
//
// SPRD-04 (success criterion): "tab strip lives in the left-panel option
// card" — this component is the SPRD-04 surface.
//
// Spacing per UI-SPEC §"Spacing Scale": xl (`gap-8`) between the SpreadTabStrip
// and the BatchSetStrip — section divider, line 199.

import type * as React from "react";
import { BatchSetStrip } from "./BatchSetStrip";
import { SpreadTabStrip } from "./SpreadTabStrip";

export interface SpreadLeftPanelProps {
  /** Active spread id — passed through to the tab strip. */
  activeSpreadId?: string | undefined;
  /** Click handler for the "+ New {container}" button. */
  onCreateNewSpread?: (() => void) | undefined;
}

export function SpreadLeftPanel(props: SpreadLeftPanelProps): React.ReactElement {
  return (
    <div className="flex flex-col gap-8 p-4">
      <SpreadTabStrip
        activeSpreadId={props.activeSpreadId}
        onCreateNew={props.onCreateNewSpread}
      />
      <BatchSetStrip />
    </div>
  );
}
SpreadLeftPanel.displayName = "SpreadLeftPanel";
